import { SkyscannerResultsV3 } from "../avia";

export namespace AviaModuleTest {

	export class Configurator implements Persistance{
		showDuplicates: boolean;
		filterByAgentType: SkyscannerResultsV3.AgentType;

		constructor(persistance?: Persistance) {
			this.showDuplicates = persistance ? persistance.showDuplicates : false;
			this.filterByAgentType = persistance ? persistance.filterByAgentType : SkyscannerResultsV3.AgentType.Airline;
		}

		agentTypeCondition = (): SkyscannerResultsV3.AgentType => {

			if (this.filterByAgentType === SkyscannerResultsV3.AgentType.Default) {
				return null;
			}
		
			return this.filterByAgentType;
		}
		
	}

	export interface Persistance {
		showDuplicates: boolean;
		filterByAgentType: SkyscannerResultsV3.AgentType;
	}
}